module.exports = __webpack_public_path__ + "static/media/img109_R.f3fc7a6b.jpg";